<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage hide-button="true" :page-titles="pageTitles" />
      <low-stocks-component @edit-stock="openStockQuantityEditModal" />
      <b-modal
        id="change-quantity"
        title="Atualizar quantidade"
        title-class="font-18"
      >
        <div v-if="stock.obra && stock.insumo" class="row">
          <div class="col-12">
            <div>
              <span
                >{{ stock.obra.nome }},
                {{
                  stock.insumo.codigo.$numberDecimal
                    ? stock.insumo.codigo.$numberDecimal
                    : stock.insumo.codigo
                }}
                - {{ stock.insumo.descricao }}</span
              >
            </div>
            <br />
            <b-form-group
              id="input-change-quantity-minimum"
              label="Quantidade de estoque mínimo"
              label-for="input-change-quantity-minimum"
            >
              <b-form-input
                id="input-change-quantity-minimum"
                v-model="stock.insumo.estoqueBaixo"
                type="number"
                placeholder="Digite a quantidade"
                required
              />
            </b-form-group>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="light" @click="closeStockQuantityEditModal"
            >Cancelar</b-button
          >
          <b-button variant="primary" @click="changeQuantityById(stock)"
            >Salvar</b-button
          >
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import LowStocksComponent from '@/src/components/estoque/low-stocks.vue'
import alertMixin from '@/src/mixins/alertMixin'
import InsumoService from '@/src/services/serviceInsumoObra'

export default {
  name: 'LowStock',
  components: { Layout, HeaderPage, LowStocksComponent },
  mixins: [alertMixin],
  data() {
    return {
      stock: {},
      pageTitles: {
        title: 'Estoque Mínimo',
        subTitle: 'Gerenciamento de Estoque Mínimo',
      },
      isLoading: false,
    }
  },
  methods: {
    openStockQuantityEditModal(stock) {
      this.stock = stock
      this.$bvModal.show('change-quantity')
    },
    closeStockQuantityEditModal() {
      this.$bvModal.hide('change-quantity')
    },
    async changeQuantityById(stock) {
      this.isLoading = true
      try {
        await InsumoService.updateQuantityMinimum(
          stock.insumo._id,
          Number(stock.insumo.estoqueBaixo)
        )

        this.stock = {}
        this.closeStockQuantityEditModal()
        this.successMessage('Atualizado com sucesso')
        window.location.reload()
      } catch (error) {
        this.errorMessage(
          `Erro ao atualizar quantidade mínima do Estoque: ${
            error.response.data.error.message
          }`
        )
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
